import { BehaviorSubject, Subject } from 'rxjs';

import { PrivaWizardStep } from '@priva/components/wizard/indicator';

export class AppWizardStep implements PrivaWizardStep {
    completed = false;
    iconClass = '';
    id = 0;
    title = '';

    active$ = new BehaviorSubject<boolean>(false);

    canGoNext$ = new BehaviorSubject<boolean>(true);
    next$ = new Subject<void>();

    show(): void {
        this.active$.next(true);
        this.onShow();
    }

    hide(): void {
        this.onHide();
        this.active$.next(false);
    }

    setTitle(title: string): void {
        this.title = title;
    }

    protected onShow(): void {
        // method can be overridden is some derived classed
    }

    protected onHide(): void {
        // method can be overridden is some derived classed
    }
}
